<template>
  <MobileHeader :tabs="$route.name" isShowHeader></MobileHeader>

  <Sticky
    :top="47"
    :show="47"
    Class="scroll_top_tabs"
    stickyClass="scroll_top_tabs"
    :stickyShowBefore="true"
    v-if="isMobile"
  >
    <Picker
      ref="newsLanguagePicker"
      v-if="currentLanguageList.length > 0"
      v-model:show="showPicker"
      :list="currentLanguageList"
      @cancel="showPicker = false"
      @confirm="handleConfirmPicker"
      @selected="handleNewsLangSelect"
      title="SELECT_LANG"
      :selected="newsLangSelect"
      :columnsFieldNames="{ text: 'displayName', value: 'locale' }"
      :content="['', 'displayName', '']"
    >
      <template #mobileButton>
        <div
          class="news-language__selection-wrapper"
          @click="openPicker()"
          v-if="isMobileRealTime && newsLangSelect.selectedLangObj !== null"
        >
          <div class="news-language__selected-pill btn-aspn-only-default 2">
            <div class="news-language__selected-name">
              {{ newsLangSelect?.selectedLangObj?.displayName }}
            </div>
            <div
              class="news-language__list-caret"
              :class="{ active: newsLangSelect.isShowList }"
            >
              <SvgIcon icon="c.header.newsCaret" />
            </div>
          </div>
        </div>
      </template>
    </Picker>

    <div class="sub-tab__wrapper">
      <router-link
        :to="{ name: o.pathName }"
        v-for="(o, index) in newsSportType"
        :key="index"
        class="sub-tab"
        :class="{ active: o.selected }"
        >{{ $t(o.name) }}</router-link
      >
    </div>
  </Sticky>
  <div class="scrollTop116"></div>

  <div class="news-container news-page-container pb-1rem">
    <div
      :class="{
        'container has-space has-header': !isMobile,
      }"
    >
      <div class="news-header" v-if="!isMobile">
        <div class="flex-fixed-width"></div>
        <div class="sub-tab__wrapper" v-if="!isMobile">
          <router-link
            :to="{ name: o.pathName }"
            v-for="(o, index) in newsSportType"
            :key="index"
            class="sub-tab"
            :class="{ active: o.selected }"
            >{{ $t(o.name) }}</router-link
          >
        </div>
        <Picker
          ref="newsLanguagePicker"
          v-if="currentLanguageList.length > 0 && isMobile"
          v-model:show="showPicker"
          :list="currentLanguageList"
          @cancel="showPicker = false"
          @confirm="handleConfirmPicker"
          @selected="handleNewsLangSelect"
          title="SELECT_LANG"
          :selected="newsLangSelect"
          :columnsFieldNames="{
            text: 'displayName',
            value: 'locale',
          }"
          :content="['', 'displayName', '']"
        >
          <template #mobileButton>
            <div
              class="news-language__selection-wrapper"
              @click="openPicker()"
              v-if="isMobileRealTime && newsLangSelect.selectedLangObj !== null"
            >
              <div class="news-language__selected-pill btn-aspn-only-default 3">
                <div class="news-language__selected-name">
                  {{ newsLangSelect?.selectedLangObj?.displayName }}
                </div>
                <div
                  class="news-language__list-caret"
                  :class="{
                    active: newsLangSelect.isShowList,
                  }"
                >
                  <SvgIcon icon="c.header.newsCaret" />
                </div>
              </div>
            </div>
          </template>
        </Picker>

        <div class="sub-tab__wrapper" v-if="isMobile">
          <router-link
            :to="{ name: o.pathName }"
            v-for="(o, index) in newsSportType"
            :key="index"
            class="sub-tab"
            :class="{ active: o.selected }"
            >{{ $t(o.name) }}</router-link
          >
        </div>

        <div class="flex-fixed-width"></div>
      </div>
      <div class="display-flex-center">
        <LoadingAspn type="news-2" v-if="isLoading" />
        <!-- <van-loading v-if="isLoading" /> -->
      </div>
      <div v-show="!isLoading && !isShowNoData">
        <div class="news-content-box">
          <div class="news-page-main-wrapper">
            <h1 class="news_top-stories__title">
              <span v-if="newsCateogoriesList && newsCateogoriesList[1]">
                {{ newsCateogoriesList[1].name }}
              </span>
            </h1>

            <!-- <Teleport to="#news-language-selection-portal" v-if="isMobile && newsLangSelect.selectedLangObj !== null">
                        <div id="mobileNewsLangSelection" class="news-language__selection-wrapper">
                            <div class="news-language__selected-pill">
                                <div class="news-language__selected-name">{{ newsLangSelect.selectedLangObj.displayName }}</div>
                                <div class="news-language__list-caret" :class="{ active: newsLangSelect.isShowList }">
									<SvgIcon icon="c.header.newsCaret" />
                                </div>
                            </div>
                        </div>
                    </Teleport> -->
          </div>
          <div class="news_top-stories__wrapper">
            <template
              v-if="
                newsCateogoriesList &&
                newsCateogoriesList[1] &&
                newsCateogoriesList[1].news &&
                !isLoading
              "
              :key="index"
            >
              <router-link
                :to="{
                  name: 'newsDetail',
                  params: {
                    title: newsCateogoriesList[1].news[0].urlName,
                    id: newsCateogoriesList[1].news[0].id,
                    currentSportType:
                      newsCateogoriesList[1].news[0]?.sportTypePath,
                  },
                }"
              >
                <div class="news-item first">
                  <div class="news-image">
                    <div class="ratio-169-container" v-if="isMobile"></div>
                    <img
                      class="news-image--coverImg"
                      :src="`${s3ImgUrl}/${newsCateogoriesList[1].news[0].coverImage}`"
                    />
                  </div>
                  <div class="news-content">
                    <div class="news-title">
                      {{ newsCateogoriesList[1].news[0].title }}
                    </div>
                    <div class="news-date">
                      {{ newsCateogoriesList[1].news[0].publishedOn }}
                    </div>
                  </div>
                </div>
              </router-link>
              <div class="news-list">
                <template
                  v-for="(item, index) in newsCateogoriesList[1].news"
                  :key="index"
                >
                  <router-link
                    :to="{
                      name: 'newsDetail',
                      params: {
                        title: item.urlName,
                        id: item.id,
                        currentSportType: item.sportTypePath,
                      },
                    }"
                    v-if="index > 0"
                  >
                    <div class="news-item" :class="{ first: isMobile }">
                      <div class="news-image">
                        <div class="ratio-169-container" v-if="isMobile"></div>
                        <img
                          class="news-image--coverImg"
                          :src="`${s3ImgUrl}/${item.coverImage}`"
                        />
                      </div>
                      <div class="news-content">
                        <div class="news-title">
                          {{ item.title }}
                        </div>
                        <div class="news-date">
                          {{ item.publishedOn }}
                        </div>
                      </div>
                    </div>
                  </router-link>
                </template>
              </div>
            </template>
          </div>
        </div>

        <div class="news-mobile-ads-box">
          <img
            src="../../../static/images/icons/aspn_icon/player/news_ads_mobile_1.png"
            class="news-mobile-ads"
          />
        </div>
      </div>
      <NoData
        v-show="isShowNoData && !isLoading"
        text="NO_NEWS"
        class="mb-1rem"
        :class="isMobile ? 'ma-05rem' : ''"
      ></NoData>
    </div>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from "swiper/vue";
import SwiperCore, { Pagination, Navigation, Autoplay } from "swiper/core";
SwiperCore.use([Pagination, Navigation, Autoplay]);
import MobileSelect from "mobile-select"; //"@/lib/mobile-select/mobile-select";

import moment from "moment";

import config from "@/js/config.js";
import MobileHeader from "@/components/mobile/Header.vue";
import NewCategoriesCard from "@/components/news/NewCategoriesCard.vue";
import { mapState, mapGetters, mapActions, mapMutations } from "vuex";
import Sticky from "@/components/sticky/Sticky.vue";
import Picker from "@/components/picker/Picker.vue";

export default {
  components: {
    Swiper,
    SwiperSlide,
    MobileHeader,
    NewCategoriesCard,
    Sticky,
    Picker,
  },
  watch: {
    $route() {
      // location.reload();
      //this.setSelectedNewsLang();
    },
    userSwitchCountryLang: {
      handler(newVal, oldVal) {
        if (newVal && this.currentLanguageObj.displayName === "English") {
          this.setSelectedNewsLang();
        }
      },
    },
    newsLangSelected(newVal) {
      this.setSelectedNewsLang(newVal);
    },
  },
  data() {
    return {
      showPicker: false,
      s3ImgUrl: config.s3ImgUrl,
      newsCateogoriesList: [],
      topStoriesList: {},
      isShowTopStoriesSwiper: true,
      isLoading: true,
      isShowNoData: false,
      newsLangSelect: {
        selectedLangObj: null,
        isShowList: false,
        msInstance: null,
      },
      newsSportType: [
        {
          name: "TEAM",
          id: "TEAM",
          pathName: "news",
          selected: false,
        },
        {
          name: "LATEST",
          id: "LATEST",
          pathName: "latestNews",
          selected: false,
        },
        {
          name: "COMPETITION",
          id: "COMPETITION",
          pathName: "competitionNews",
          selected: false,
        },
      ],

      currentNewsSportType: "ALL",
    };
  },
  computed: {
    ...mapState(["newsLangSelected", "scrollTop"]),
    ...mapGetters([
      "isMobile",
      "isMobileRealTime",
      "currentLanguageObj",
      "currentLocale",
      "currentSportType",
      "currentLanguageList",
      "isLogin",
      "userSwitchCountryLang",
    ]),
  },
  mounted() {
    this.commonVerifyLogin();

    this.handleNewsSportType();
    let locale = localStorage.getItem("newsLang");
    if (locale) {
      this.setSelectedNewsLang(JSON.parse(locale));
    } else {
      this.setSelectedNewsLang();
    }
  },
  methods: {
    ...mapMutations(["SET_USER_COUNTRY_CODE"]),
    ...mapActions([
      "getAllNewsList",
      "commonVerifyLogin",
      "getCountryCodeByIp",
      "currentCountryChangeEvent",
    ]),

    setSelectedNewsLang(o = null) {
      // if(this.newsLangSelected) {
      //     o = this.newsLangSelected
      // }
      localStorage.setItem("newsLang", JSON.stringify(o));
      if (o === null) {
        //this.newsLangSelect.selectedLangObj
        this.newsLangSelect.selectedLangObj = this.currentLanguageObj;
      } else {
        this.newsLangSelect.selectedLangObj = o;
      }

      this.$nextTick(() => this.getAllNewsListData("ALL"));
    },

    mobileLangSelection(selectedLocale) {
      if (!this.isMobile) return;
      this.$nextTick(() => {
        let triggerId = "#mobileNewsLangSelection";
        let title = this.$i18n.t("SELECT_LANGUAGE");
        let ensureBtnText = this.$i18n.t("DONE");
        let cancelBtnText = this.$i18n.t("CANCEL");

        let ensureBtnColor = "var(--color-text-primary-default)";
        let titleBgColor = "#F0F0F0";
        let selectedIndex;

        //  if (this.newsLangSelect.msInstance === null) {
        //      let langSelectData = [];
        //      // store vue js this to that
        //      let that = this;

        //      this.currentLanguageList.forEach((ele, i) => {
        //          langSelectData.push({
        //              id: ele.locale,
        //              value: ele.displayName,
        //          });

        //          if (selectedLocale === ele.locale) {
        //              selectedIndex = i;
        //          }
        //      });

        //      this.newsLangSelect.msInstance = new MobileSelect({
        //          trigger: triggerId,
        //          triggerDisplayData: false,
        //          title: title,
        //          ensureBtnText: ensureBtnText,
        //          cancelBtnText: cancelBtnText,
        //          ensureBtnColor: ensureBtnColor,
        //          titleBgColor: titleBgColor,
        //          wheels: [{ data: langSelectData}],
        //          triggerDisplayValue: false,

        //          onShow: function() {
        //              that.newsLangSelect.isShowList = true;
        //          },

        //          onHide: function() {
        //              that.newsLangSelect.isShowList = false;
        //          },

        //          callback: function(indexArr, data) {
        //              let selectedLangObj = that.currentLanguageList.filter(ele => ele.locale === data[0].id);
        //              selectedIndex = indexArr;
        //              that.setSelectedNewsLang(selectedLangObj[0]);
        //          },
        //      });

        //      this.newsLangSelect.msInstance.locatePosition(0, selectedIndex);
        //  }
      });
    },

    async getAllNewsListData(sportType) {
      if (!this.isLogin && !this.userCountryCode) {
        let result = await this.getCountryCodeByIp();
        if (result.message === "Success") {
          let countryCode = result.result.countryCode;

          // this.SET_USER_COUNTRY_CODE(countryCode);

          this.currentCountryChangeEvent(countryCode);
        }
      }

      let params = {
        language: this.newsLangSelect?.selectedLangObj?.locale
          ? this.newsLangSelect.selectedLangObj.locale
          : this.currentLanguageObj.locale,
        sportType: sportType,
      };

      this.isShowNoData = false;
      this.isLoading = true;
      this.mobileLangSelection(params.language);

      const result = await this.getAllNewsList(params);

      //reset news data variable
      this.newsCateogoriesList = [];
      this.topStoriesList = [];
      let data = result.result;
      if (data && data.length > 0) {
        for (let i = 0; i < data.length; i++) {
          data[i].urlName = data[i].name.toLowerCase().replace(/\s/g, "-");
          for (let x = 0; x < data[i].news.length; x++) {
            let convertedDate;
            let A = moment(data[i].news[x].publishedOn);
            let B = moment();
            let diffDays = A.diff(B, "days");

            if (diffDays > 0) {
              convertedDate = moment(data[i].news[x].publishedOn).fromNow();
            } else {
              convertedDate = moment(data[i].news[x].publishedOn).format(
                "dddd D MMM YYYY"
              );
            }
            let theNewsData = data[i].news[x];
            if (theNewsData.sportType == "SOCCER") {
              theNewsData.sportTypePath = "football";
            } else {
              theNewsData.sportTypePath = theNewsData.sportType.toLowerCase();
            }
            data[i].news[x].urlName = data[i].news[x].title
              .toLowerCase()
              .replace(/\s/g, "-");
            data[i].news[x].publishedOn = moment(
              data[i].news[x].publishedOn
            ).fromNow(); //moment("2019-09-10T07:53:06.000+00:00").fromNow(); //
          }
        }

        this.topStoriesList = data[0];
        if (this.topStoriesList.news.length > 3) {
          this.isShowTopStoriesSwiper = true;
        } else {
          this.isShowTopStoriesSwiper = false;
        }

        //  data.shift();
        this.newsCateogoriesList = data;
      } else {
        this.isShowNoData = true;
      }
      this.isLoading = false;
    },

    handleNewsSportType(o) {
      let pathName = window.location.pathname;
      if (pathName.charAt(0) == "/") {
        pathName = pathName.substring(1);
      }
      let urlExtract = pathName.split("/");
      let currentSportType = "for_you";
      if (urlExtract.length > 2) {
        currentSportType = urlExtract[2];
      }

      for (let i = 0; i < this.newsSportType.length; i++) {
        this.newsSportType[i].selected = false;
        if (
          this.newsSportType[i].name.toLocaleLowerCase() === currentSportType
        ) {
          this.newsSportType[i].selected = true;
          this.currentNewsSportType = this.newsSportType[i].id;
        } else {
        }
      }

      this.getAllNewsListData("ALL");
    },

    handleNewsLangSelect(o) {
      this.newsLangSelect.isShowList = false;
      this.setSelectedNewsLang(o);
    },
    openPicker() {
      if (!this.isLoading) {
        this.showPicker = !this.showPicker;
      }
    },
    handleConfirmPicker(o) {
      let item = o.selectedOptions[0];
      this.handleNewsLangSelect(item);
      this.showPicker = false;
    },
  },
};
</script>

<style lang="css" scoped src="@/assets/css/news/index.css" />

<style>
.scroll_top_tabs {
  position: fixed;
  width: 100%;
  top: 47px;
}
</style>
